import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ICourseCreateRequest } from "common/types";
import api from "common/api";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";

function CourseNewsCreateModal({ show, onHide, onNewsCreate, course }: any) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const createNews = async (news: ICourseCreateRequest) => {
    try {
      const response = await api.post("/news/", news);
      toast.success("Novost dodana");
      setTitle("");
      setContent("");
      onNewsCreate(response.data);
    } catch (error) {
      console.log(error);
      toast.error("Greška prilikom dodavanja novosti");
    }
  };

  async function handleCreateNews() {
    console.log("course");
    console.log(course);
    const newsItem = {
      course: course.id,
      title: title,
      content: content,
    };

    await createNews(newsItem);
    onHide();
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Dodaj novost</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Naslov
          </label>
          <input
            type="text"
            className="form-control"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            autoFocus
          />
        </div>
        <div className="mb-3">
          <Form.Group>
            <Form.Label>Sadržaj</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              id="content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </Form.Group>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Odustani
        </Button>
        <Button onClick={handleCreateNews}>Dodaj</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CourseNewsCreateModal;
